module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./WxLoginTipView.js"));
	}, "WxLoginTipView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WxLoginTipView!./src/pages/Login/WxLoginTip/WxLoginTipView.js
// module id = 836
// module chunks = 438